// extracted by mini-css-extract-plugin
export default {"info":"delete-release-modal_info__9mJ78","text":"delete-release-modal_text__W3sur","button":"delete-release-modal_button__KtitA"};